import React from "react";
import { Switch, Route } from 'react-router-dom';

import { Pages } from "components/pages";
import { UserHelpers } from "components/user";
import checkUser from "utils/check-user";
import { useVarParam } from "components/use-hooks";

const { permission } = UserHelpers;
const { Stands } = Pages;

const StandRoutes = () => {
    const varParam = useVarParam();
    const me = varParam.get("me");

    const hasActiveEventWithoutPermission =
        checkUser.hasEvents(me.exhibitionEvent) &&
        checkUser.isEventPermitted(me) &&
        !!me.eeCurrentId;

    return(
        <Switch>
            { hasActiveEventWithoutPermission &&
                <Route path="/stands/" exact>
                    <Stands.Collection />
                </Route>
            }
            <Route path="/stands/:standId" exact>
                { ( { match } ) =>
                    <Stands.Single standId={ +match.params.standId }  />
                }
            </Route>
            <Route path="/stands/:standId/keys" exact>
                { ( { match }) =>
                    <Stands.Keys standId={ +match.params.standId }  />
                }
            </Route>
            { permission().has({ type : "log" }) &&
                <Route path="/stands/:standId/log" exact>
                    { ( { match }) =>
                        <Stands.Log standId={ +match.params.standId }  />
                    }
                </Route>
            }
            <Route path="*" >
                <Pages.Page404 />
            </Route>
        </Switch>
    );
};

export default StandRoutes;